<template>
  <section class="main">
    <div v-show="isLoading">
      <v-page-loading />
    </div>
    <div v-show="!isLoading">
      <div class="grid-container">
        <div class="grid-x grid-margin-x align-center align-middle">
          <div class="cell small-auto medium-2">
            <v-datepicker
              id="pickdate"
              class="form-control form-control--small form-control--date"
              :placeholder="$t('search.from')"
              :format="$t('search.from') + ' ' + $helpers.dateFormat"
              :clearButton="true"
              :disabled-dates="$helpers.disabledDates"
              :language="de"
              :monday-first="true"
              v-model="calendar.startdate"
            />
          </div>
          <div class="cell small-auto medium-2">
            <button
              v-on:click.prevent="onChangeCalendarDate"
              role="button"
              type="submit"
              class="button"
              title="Ändern"
            >Datum Auswählen</button>
          </div>
          <div class="cell small-auto medium-2">
            <button
              v-on:click.prevent="getPrevCalendar"
              role="button"
              type="submit"
              class="button button--prev button--calendar"
              :title="$t('backward')"
            >{{ $t('backward')}}</button>
            <button
              v-on:click.prevent="getNextCalendar"
              role="button"
              type="submit"
              class="button button--next button--calendar"
              :title="$t('forward')"
            >{{ $t('forward') }}</button>
          </div>
          <div class="cell small-auto medium-1">
            <select
              name="viewsize"
              v-model="viewsize"
              @change="viewSize"
              title="Darstellung Einstellung"
            >
              <option disabled value>Skalierung</option>
              <option value="1">100%</option>
              <option value=".95">95%</option>
              <option value=".90">90%</option>
              <option value=".85">85%</option>
              <option value=".80">80%</option>
              <option value=".75">75%</option>
              <option value=".70">70%</option>
            </select>
          </div>
        </div>
      </div>

      <div class="grid-container full" v-bind:style="scaling">
        <div class="grid-x grid-margin-x text-center">
          <div class="cell auto">
            <div class="c-calendar-slider">
              <div
                v-for="(item, index) in this.dates"
                :key="index"
                class="c-calendar-slider__item box"
              >
                <v-week-group :startdate="item" :index="index" :holidays="holidays"></v-week-group>
              </div>
            </div>
          </div>
        </div>
        <div
          class="grid-container u-extra-medium-margin--top u-extra-medium-margin--bottom text-center"
        >
          <h2 class="u-extra-small-margin--bottom">{{ $t('weeks.parkinglot.title') }}</h2>
          <draggable
            tag="div"
            class="c-parking-lot-wrapper"
            animation="150"
            group="week"
            draggable=".c-parking-lot-item"
            :sort="false"
            :data-parkinglot="1"
            v-model="parked_entries"
            @end="onEndDrag"
          >
            <div
              v-if="parked_entries.length === 0"
              class="text-center empty-message"
            >{{ $t('weeks.parkinglot.empty') }}</div>
            <div
              class="c-parking-lot-item"
              v-for="entry in parked_entries"
              :data-entry_id="entry.id"
              :data-date="$moment(entry.startdate).format('YYYY-MM-DD')"
              :data-kolonne="entry.kolonne"
              :key="entry.id"
            >
              <template v-if="entry.project">
                <span>
                  <strong>{{ entry.project.customer.company_name}}</strong>
                </span>
                <span>{{ entry.project.address.city }}</span>
                <router-link
                  :to="{ name : 'customers-update-customer-project', params : { customer : entry.project.customer.company_id, project : entry.project_id } }"
                  class="u-subtil-link"
                  :title="$t('update')"
                >
                  <strong>{{ entry.project.project_number }}</strong>
                </router-link>
              </template>
              <template v-else>
                <router-link
                  :to="{ name : 'update-tour', params: {tour: entry.tour_id} }"
                  :title="$t('update')"
                  class="u-subtil-link"
                >
                  <strong>{{ entry.tour.tour_number }}</strong>
                </router-link>
              </template>

              <v-week-day-content-day-graphic :numberOfDays="calcNumberOfDays(entry)"></v-week-day-content-day-graphic>
            </div>
          </draggable>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import WeekGroup from "./partials/weekGroup";
import Datepicker from "vuejs-datepicker";
import { de } from "vuejs-datepicker/dist/locale";
import PageLoading from "./../partials/PageLoading";
import draggable from "vuedraggable";
import WeekDayContentDayGraphic from "./partials/weekDayContentDayGraphic";

export default {
  name: "Calendar",
  data: function() {
    return {
      scaling: {
        transform: "scale(1)",
        "transform-origin": "top center"
      },
      de: de,
      viewsize: 1,
      loading: false,
      dates: [],
      calendar: {
        limit: 3,
        startdate: this.getStartDate()
      },
      holidays: {},
      parked_entries: []
    };
  },

  components: {
    vWeekDayContentDayGraphic: WeekDayContentDayGraphic,
    vDatepicker: Datepicker,
    vWeekGroup: WeekGroup,
    vPageLoading: PageLoading,
    draggable
  },

  mounted: function() {
    this.getCalendarDates();
    this.getParkedEntries();
  },

  created: function() {
    this.getHolidays();
    this.setViewSize();
  },

  computed: {
    isLoading: function() {
      return this.loading;
    }
  },
  methods: {
    getStartDate: function() {
      if (this.$route.params.date) {
        return this.$moment(this.$route.params.date, "YYYY-MM-DD").format();
      }
      return this.$moment()
        .add(1, "week")
        .format();
    },

    getCalendarDates: function() {
      this.loading = true;
      // get selected date, set it to beginning of work week.
      let currentDate = this.$moment(this.calendar.startdate)
        .startOf("week")
        .subtract(1, "week");

      this.setDates(currentDate);
    },

    getNextCalendar: function() {
      let setDate = this.$moment(this.dates[1]);
      let newDate = setDate
        .clone()
        .add(1, "week")
        .format("YYYY-MM-DD");
      this.$router.replace({ name: "weeks", params: { date: newDate } });
      this.setDates(setDate);
    },

    getPrevCalendar: function() {
      let setDate = this.$moment(this.dates[1]).subtract(1, "week");
      let newDate = setDate.clone().format("YYYY-MM-DD");
      this.$router.replace({ name: "weeks", params: { date: newDate } });
      this.setDates(setDate);
    },

    onChangeCalendarDate: function() {
      let currentDate = this.$moment(this.calendar.startdate).startOf("week");
      this.$router.replace({
        name: "weeks",
        params: { date: currentDate.format("YYYY-MM-DD") }
      });

      this.getCalendarDates();
    },

    setDates: function(setDate) {
      this.dates = []; // Setup our dates for calendar views
      for (let step = 0; step < this.calendar.limit; step++) {
        let thisDate = setDate.clone().add(step, "week");
        this.dates.push(thisDate._d);
      }
      this.loading = false;
    },

    getHolidays: function() {
      this.holidays = this.$store.getters.getHolidays;
    },

    getParkedEntries: function() {
      let promise = this.$api
        .clearParams()
        .addParam("parked", 1)
        .addParam("byweek", true)
        .get("weekplan");

      promise
        .then(
          (response => {
            this.parked_entries = response.data.data;
          }).bind(this)
        )
        .catch(
          (error => {
            window.app.$helpers.logger(error);
          }).bind(this)
        );
    },

    onEndDrag: function(event) {
      let entryId = event.item.dataset.entry_id;
      if (!entryId || parseInt(entryId) === 0) {
        return false;
      }

      let body = {
        entry_id: parseInt(entryId),
        from_date: event.item.dataset.date,
        from_kolonne: event.item.dataset.kolonne,
        to_date: event.to.dataset.date,
        to_kolonne: event.to.dataset.kolonne
      };

      let promise = this.$api.clearParams().post("weekplan/reschedule", body);

      promise
        .then(() => {
          this.getCalendarDates();
          this.getParkedEntries();
        })
        .catch(error => {
          window.app.$helpers.logger(error);
        });
    },

    calcNumberOfDays: function(entry) {
      return (
        this.$moment(entry.enddate).diff(
          this.$moment(entry.startdate),
          "days"
        ) + 1
      );
    },

    setViewSize: function() {
      if (
        localStorage.getItem("weekplanner-scaling") !== null &&
        localStorage.getItem("weekplanner-scaling") != ""
      ) {
        this.viewsize = localStorage.getItem("weekplanner-scaling");
        this.viewSize();
      }
    },
    viewSize: function(value) {
      this.scaling.transform = "scale(" + this.viewsize + ")";
      localStorage.setItem("weekplanner-scaling", this.viewsize);
    }
  }
};
</script>
